import React from "react";

const Checkbox = ({ checked, onChange }) => {
  const handleChange = () => {
    onChange && onChange({ target: { value: !checked } });
  };
  return (
    <input
      type="checkbox"
      className="form-check"
      checked={checked}
      onChange={handleChange}
    />
  );
};

export default Checkbox;
